import { render, staticRenderFns } from "./ListPage.vue?vue&type=template&id=387ad64c&scoped=true"
import script from "./ListPage.vue?vue&type=script&lang=ts"
export * from "./ListPage.vue?vue&type=script&lang=ts"
import style0 from "./ListPage.vue?vue&type=style&index=0&id=387ad64c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387ad64c",
  null
  
)

export default component.exports